import {
  LineChart,
  Line,
  XAxis,
  ResponsiveContainer,
  YAxis,
  Tooltip,
} from "recharts";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

// ----------------------------------------------------------------------------

interface OverviewChartDataPoint {
  name: string;
  value: number;
}

interface OverviewChartProps {
  className?: string;
  data: OverviewChartDataPoint[];
  isLoading?: boolean;
}

export function OverviewChart(props: OverviewChartProps) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { className, data, isLoading = false } = props;

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  return (
    <Card className={`shadow-sm ${className || ""}`}>
      <CardHeader>
        <CardTitle className="text-lg font-bold">
          Fatturato nel periodo
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="mt-4 space-y-4">
            <Skeleton className="h-[300px] w-full" />
          </div>
        ) : (
          <div className="mt-4 h-[300px] w-full">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart
                data={data}
                margin={{ top: 20, right: 10, left: 10, bottom: 0 }}
              >
                <XAxis
                  dataKey="name"
                  axisLine={false}
                  tickLine={false}
                  tick={{ fill: "#6B7280", fontSize: 12 }}
                  dy={10}
                />
                <YAxis hide domain={[0, "dataMax"]} />
                <Tooltip
                  formatter={(value) =>
                    new Intl.NumberFormat("it-IT", {
                      style: "currency",
                      currency: "EUR",
                    }).format(typeof value === "number" ? value : 0)
                  }
                />
                <Line
                  type="monotone"
                  dataKey="value"
                  stroke="#0D6EFD"
                  strokeWidth={2}
                  dot={false}
                  activeDot={{ r: 6 }}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        )}
        {!isLoading && data.length === 0 && (
          <p className="text-sm text-gray-500 mt-4">
            Nessun dato disponibile nel range selezionato.
          </p>
        )}
      </CardContent>
    </Card>
  );
}
